/* eslint-disable react/self-closing-comp */
import React, { Component } from 'react';

import CircleWithPerson from '../../../componentLibrary/foundations/Icon/icons/utility/CircleWithPerson';

export class NMLoginButtonComponent extends Component {
  render() {
    return (
      <div
        className='nm-login-button'
        ref={this.loginButtonComponent}>
        <a
          id='nmx-login-link'
          className='nmx-login-link nmx-nav-link nmx-nav-link-utility'
          href='https://login.northwesternmutual.com'
          aria-label='Log into your Northwestern Mutual account'>
          <CircleWithPerson />Log in
        </a>
      </div>
    );
  }
}

export default NMLoginButtonComponent;
